<template>
  <div class="pro_index">
    <el-container>
      <el-aside
        v-if="user.userType != '00'"
        style="width: 215px;overflow: hidden;"
      >
        <ul class="left_url_tab">
          <el-menu
            v-if="showMenu"
            :default-openeds="openeds"
            :collapse="false"
            default-active="2"
          >
            <!-- 菜单 -->
            <el-submenu
              :index="menu.name"
              v-for="(menu, count) in leftMenu"
              :key="count"
            >
              <template slot="title">
                <img v-if="menu.meta.title === '设计成果'" :src="imageDesign" />
                <img v-if="menu.meta.title === 'Amazon'" :src="imageAmazon" />
                <img v-if="menu.meta.title === '通用功能'" :src="imageOper" />
                <img v-if="menu.meta.title === '通用数据'" :src="imageOper" />
                <img v-if="menu.meta.title === 'Shopify'" :src="imageOper" />
                <img v-if="menu.meta.title === 'Shopline'" :src="imageOper" />
                <img v-if="menu.meta.title === '店匠'" :src="imageOper" />
                <span>{{ menu.meta.title }}</span>  
              </template>
              <el-menu-item-group>
                <el-menu-item
                  style="padding-left: 48px;"
                  @click.native="
                    jumpPage(resolvePath(topPath, menu.path, child.path))
                  "
                  :index="menu.name + '-' + child.name"
                  v-for="(child, index) in menu.children"
                  :key="index"
                  v-show="!child.hidden"
                >
                  {{ child.meta.title }}</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
          <OnlineMenu v-else></OnlineMenu>
        </ul>
        <!--商品滚动播放-->
        <Broadcast></Broadcast>
      </el-aside>
      <el-main class="child-content">
        <router-view> </router-view>
      </el-main>
    </el-container>
    <ClassManage
      @closeCMDialog_z="closeCMDialog_f"
      :classManageDialog="classManageDialog"
    ></ClassManage>
  </div>
</template>

<script type="text/ecmascript-6">



import path from "path"
import ClassManage from '@/components/product/ClassManage'
import {getTreeList,verSearch} from '@/api/product/amazon'
import {mapGetters} from 'vuex'
import {getTree} from '@/api/tree/tree';
import Broadcast from '@/components/common/Broadcast'
import imageDesign from "@/assets/images/user/design.png"
import imageAmazon from "@/assets/images/user/amazon.png"
import imageOper from "@/assets/images/user/oper.png"

export default {
    name: "index",
    components:{
        ClassManage,
        Broadcast
    },
    data() {
        return {
            classManageDialog:false,//管理分类弹窗默认关闭
            defaultProps: {
                children: 'children',
                label: 'label',
                value:'value',
            },
            treeData:[],
            count:1,
            idArr:['1'],//默认展开第一级
            topPath: "",
            openeds: [],
            showMenu: true,
            imageDesign: imageDesign,
            imageAmazon: imageAmazon,
            imageOper: imageOper
        }
    },
    computed:{
        ...mapGetters(['amazonTotal', 'user']),
        ...mapGetters(["permission_routes"]),
        ifReload(){
            return this.$store.state.product.amazon.ifReload;
        },
        total(){
            return this.$store.state.product.amazon.total;
        },
        leftMenu() {
          if (this.permission_routes[0] && this.permission_routes[0].children) {
            let menus = this.permission_routes[0].children
            let matched = this.$route.matched.filter(
              (item) => item.meta && item.meta.title
            )
            let munuList = matched.filter(
              (item) =>
                item.meta && item.meta.title && item.meta.breadcrumb !== false
            )
            let order = menus.filter((item) => item.path == munuList[0].path)
            this.topPath = order[0].path
            for (let menu of order[0].children) {
              this.openeds.push(menu.name)
            }
            return order[0].children
          }
        },
    },
    watch:{
        ifReload(newVal,oldVal){
            if(newVal){
                // this.loadStatusNum();
            }
        }
    },
    created() {
        let that = this;
        if(sessionStorage.getItem("orderStatus") == null){
            this.getDicts("order_status").then(response => {
                this.$store.commit('SET_ORDERSTATUS',response.data);
                sessionStorage.setItem("orderStatus",JSON.stringify(response.data));
            });
        }
        // this.hotArticle();
        // this.getMoveClassification();
    },
    methods: {
        jumpPage(url) {
          this.$router.push(url)
        },
        title2Click(e,url){
            var _dom = document.querySelector('.li-title_2.title-2-select');
            if (_dom) {
                _dom.classList.toggle('title-2-select');//当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
            }
            e.target.classList.toggle('title-2-select');
            this.$router.push(url);
        },
        setClassManage:function(){
            this.classManageDialog = true;
        },
        closeCMDialog_f:function(){
            this.classManageDialog = false;
        },
        waitForPost(val,node,tree){
            this.$router.push({path:'/product/amazon/readyRelease'})
        },
        onLineChange(){
            this.$router.push({path:'/product/amazon/onLine'})
        },
        resolvePath(firstPath, secondPath, thirdPath) {
        return path.resolve(firstPath, secondPath, thirdPath)
        },
        /**
         * 加载动态树
         */
        loadNode(node, resolve) {
            var that =this;
            if (node.level === 0) {
                //查询顶级节点
                let params = {};
                getTreeList(params).then(function(res){
                    that.treeData = that.createTreeData(res.data);
                    console.log(that.treeData);
                    return resolve(that.treeData);
                }).catch(function(error){
                    this.$message.error(res.msg);
                });
            }else {
                let params = {pTypeNo:node.data.id};
                // 根据父节点id找寻下一级的所有节点
                getTreeList(params).then(res => {
                    return resolve(res.data);
            });
            }

        },

        createTreeData(data){
            let treedata = data.filter(father =>{
                if(father['pTypeNo'] == ""||father['pTypeNo'] == null){
                father['pTypeNo'] = '0'
            }
            let childArr = data.filter(child =>{
                return  child['pTypeNo'] == father.id;
        });
            childArr.length > 0?father.children =childArr:'';
            return father['pTypeNo'] == '0';
        });
            return treedata ;
        },

        //待发布的tree点击
        readyReleaseChange(val,node,tree){
            // this.$router.push({path:'/amazon/readyRelease'})
            this.$router.push({path:"/product/amazon/readyRelease",query:{treeId:val.value}})
        },
        //在线的tree点击
        onLinereadyReleaseChange(val,node,tree){
            // this.$router.push({path:'/amazon/readyRelease'})
            this.$router.push({path:"/product/amazon/onLine",query:{treeId:val.value}})
        },
        //移动分类树形数据
        getMoveClassification(){
            getTree().then((res) => {
                this.treeData=res.data;
            })
        },


    },
    mounted() {}
}
</script>

<style scoped>
@import "../../../assets/css/product.css";
@import "../../../assets/css/Amazon.css";
.pro_index {
  width: 100%;
}
.left_url_tab {
}
.left_url_tab li:not(:last-child) {
  list-style: none;
}

.li-title_1 {
  height: 32px;
  line-height: 32px;
  background-color: #c1c1c154;
  vertical-align: top;
  padding-left: 5px;
  font-weight: 600;
}
.li-title_2 {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  padding-left: 20px;
  border-bottom: 1px solid #ccc;
}
.li-title_3 {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  padding-left: 40px;
}
.li-title_2:not(.tree-item):hover {
  background-color: #409eff;
  color: white;
  cursor: pointer;
}
.title-2-select {
  background-color: #409eff;
  color: white;
  cursor: pointer;
}
.li-help {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  text-align: center;
  font-size: 16px;
}
.li-help a {
  text-decoration: none;
  color: #409eff;
}
.tree-item {
  height: auto !important;
  padding: initial;
}
.tree-item .el-tree {
  background: initial !important;
}
.tree-item .el-tree:hover {
  background: initial !important;
}
.left_url_tab img {
  width: 15px;
  margin: 0 6px 0 0;
}
</style>
